var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-container"},[_c('div',{staticClass:"top-container"},[_c('img',{attrs:{"src":"/mediacryptos/check.svg?t=1","alt":""}}),_c('p',{staticClass:"status-text"},[_vm._v(_vm._s(_vm.$t("Success")))]),_c('p',{staticClass:"status-tips-text"},[_vm._v(_vm._s(_vm.$t("SuccessText")))])]),_c('order-num'),_c('back'),_c('fire-work')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }